import { Box } from '@chakra-ui/react';
import createMentionPlugin from '@draft-js-plugins/mention';
import { MentionSuggestionsPubProps } from '@draft-js-plugins/mention/lib/MentionSuggestions/MentionSuggestions';
import * as React from 'react';

import { Mention } from './components/Mention';

export const mentionPlugin = createMentionPlugin({
  entityMutability: 'IMMUTABLE',
  supportWhitespace: true,
  mentionComponent: Mention,
  theme: {
    mentionSuggestions: 'mentionSuggestions',
    mentionSuggestionsPopup: 'mentionSuggestionsPopup',
    mentionSuggestionsPopupVisible: 'mentionSuggestionsPopupVisible',
    mentionSuggestionsEntry: 'mentionSuggestionsEntry',
    mentionSuggestionsEntryFocused: 'mentionSuggestionsEntryFocused',
  },
});
const { MentionSuggestions } = mentionPlugin;

const entryShared = {
  paddingTop: '2',
  paddingBottom: '2',
  paddingRight: '2.5',
  paddingLeft: '2.5',
  transition: 'background-color 0.4s cubic-bezier(.27,1.27,.48,.56)',
  borderRadius: 'lg',
};

export const MentionSuggestionsWrapper: React.FC<MentionSuggestionsPubProps> = (
  props
) => {
  return (
    <Box
      sx={{
        '.mentionSuggestions': {
          position: 'absolute',
          minWidth: '56',
          maxWidth: '96',
          background: 'white',
          borderRadius: 'lg',
          boxShadow: 'lg',
          cursor: 'pointer',
          padding: '1',
          zIndex: '2',
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          transform: 'scale(0)',
        },
        '.mentionSuggestionsPopup': {
          opacity: '0',
          transition: 'opacity 0.25s cubic-bezier(0.3, 1.2, 0.2, 1)',
          borderRadius: 'lg',
        },
        '.mentionSuggestionsPopupVisible': {
          opacity: '1',
        },
        '.mentionSuggestionsEntry': {
          ...entryShared,
        },
        '.mentionSuggestionsEntry:active': {
          backgroundColor: 'gray.100',
        },
        '.mentionSuggestionsEntryFocused': {
          ...entryShared,
          backgroundColor: 'gray.100',
        },
        '.mentionSuggestionsEntryFocused:active': {
          backgroundColor: 'gray.100',
        },
      }}
    >
      <MentionSuggestions {...props} />
    </Box>
  );
};
